import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';

const TermsOfService = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: '#fbfbfb' }}>
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
          <Typography 
            variant="h3" 
            component="h1" 
            align="center" 
            gutterBottom
            sx={{ 
              color: '#0a233b',
              fontWeight: 'bold',
              mb: 4
            }}
          >
            Terms of Service
          </Typography>
          
          <Typography variant="body1" paragraph>
            Last Updated: March 28, 2025
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing or using the Lantena Property Management website and services, you agree to be bound by these Terms of Service. If you do not agree to these Terms, please do not use our services.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            2. Description of Services
          </Typography>
          <Typography variant="body1" paragraph>
            Lantena Property Management provides property management services, including but not limited to property marketing, tenant management, rent collection, accounting, and project management. The specific services available to you depend on the service plan you select.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            3. User Accounts
          </Typography>
          <Typography variant="body1" paragraph>
            Some features of our services require you to register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete. You are responsible for safeguarding your password and for all activities that occur under your account.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            4. Fees and Payment
          </Typography>
          <Typography variant="body1" paragraph>
            Certain services offered by Lantena Property Management may require payment of fees. All fees are stated in U.S. dollars and do not include taxes, which are your responsibility. Payment must be made by the methods specified, and you authorize us to charge your chosen payment provider.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            5. Intellectual Property
          </Typography>
          <Typography variant="body1" paragraph>
            The Lantena Property Management website, including its content, features, and functionality, is owned by Lantena Property Management and is protected by copyright, trademark, and other intellectual property laws. You may not reproduce, distribute, modify, create derivative works of, publicly display, or exploit any content from our website without our prior written consent.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            6. User Content
          </Typography>
          <Typography variant="body1" paragraph>
            You retain ownership of any content you submit to our website or services. By submitting content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, translate, and distribute your content in any existing or future media formats.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            7. Prohibited Activities
          </Typography>
          <Typography variant="body1" paragraph>
            You agree not to engage in any of the following prohibited activities:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 4 }}>
            <li>Violating any applicable laws or regulations</li>
            <li>Infringing on the rights of others</li>
            <li>Attempting to interfere with the proper functioning of our services</li>
            <li>Engaging in any activity that disrupts or diminishes the quality of our services</li>
            <li>Attempting to gain unauthorized access to our systems or user accounts</li>
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            8. Disclaimer of Warranties
          </Typography>
          <Typography variant="body1" paragraph>
            Our services are provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that our services will be uninterrupted, secure, or error-free.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            9. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            To the maximum extent permitted by law, Lantena Property Management shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of our services.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            10. Termination
          </Typography>
          <Typography variant="body1" paragraph>
            We may terminate or suspend your account and access to our services at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            11. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We may revise these Terms at any time by updating this page. Your continued use of our services after any changes to these Terms constitutes your acceptance of the revised Terms.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            12. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These Terms shall be governed by and construed in accordance with the laws of the state of California, without regard to its conflict of law provisions.
          </Typography>
          
          <Typography variant="h5" sx={{ color: '#0a233b', mt: 4, mb: 2 }}>
            13. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            If you have any questions about these Terms, please contact us at:
          </Typography>
          <Typography variant="body1" paragraph>
            Lantena Property Management<br />
            Email: legal@lantena.com<br />
            Phone: (555) 123-4567
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsOfService;
